import { Footer } from "antd/lib/layout/layout";
import React from "react";
import "./app-footer.scss";

export const AppFooter = () => {
  return (
    <Footer className="footer tc">
      <div>Footer</div>
    </Footer>
  );
};
